import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { featuredSites, categories, sites } from '@/mocks/sites';
import { latestArticles } from '@/mocks/articles';

interface FaqItem {
  question: string;
  answer: string;
}

const faqs: FaqItem[] = [
  {
    question: 'galgame资源网站有哪些值得推荐的？',
    answer: '我们精心整理了绯月Galgame、月幕Galgame、Galgame汉化组联合站、红茶汉化组、Galgame攻略Wiki等多个优质galgame资源网站，覆盖免费下载、汉化补丁、攻略指南和社区讨论等各个方面，满足不同玩家的需求。',
  },
  {
    question: '如何在galgame免费下载网站上安全下载游戏？',
    answer: '建议选择知名度高、社区活跃的galgame资源网站进行下载。下载前查看评论区反馈，安装杀毒软件并保持更新，对可疑文件进行安全扫描。关注汉化组官方发布渠道，避免下载被篡改的补丁文件。',
  },
  {
    question: 'galgame汉化资源网站上的补丁怎么安装？',
    answer: '通常步骤为：先安装游戏日文原版，然后将汉化补丁文件解压到游戏根目录，运行汉化后的启动程序即可。如遇乱码问题，建议使用Locale Emulator以日文环境运行游戏。具体可参考我们的汉化补丁安装教程。',
  },
  {
    question: 'galgame攻略网站有哪些好用的？',
    answer: 'Galgame攻略Wiki是最全面的攻略站点，采用流程图式展示选项分支，一目了然。此外，星空论坛Galgame区也有大量资深玩家发布的深度攻略帖，绯月Galgame的攻略板块同样值得参考。',
  },
  {
    question: '日系galgame资源在哪里找比较全？',
    answer: '绯月Galgame和ACG资源库都是日系galgame资源非常全面的站点。绯月Galgame收罗最广，从经典老作到最新发售的作品几乎都能找到；恋爱游戏网则提供详细的游戏介绍和按条件筛选功能，方便查找特定类型的作品。',
  },
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Galgame资源导航',
  url: 'https://galgame-resource.com/',
  description: '精心汇总主流galgame资源网站，涵盖免费下载、汉化补丁、攻略合集与最新资源更新，帮助玩家告别资源荒。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://galgame-resource.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const categorySiteCount: Record<string, number> = {};
sites.forEach((s) => {
  categorySiteCount[s.category] = (categorySiteCount[s.category] || 0) + 1;
});

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Anime%20style%20visual%20novel%20scene%20with%20cherry%20blossom%20petals%20drifting%20through%20a%20dreamy%20night%20sky%2C%20beautiful%20moonlight%2C%20a%20cozy%20reading%20nook%20with%20books%20and%20a%20teacup%2C%20warm%20golden%20and%20soft%20pink%20color%20palette%2C%20ethereal%20atmosphere%2C%20peaceful%20Japanese%20aesthetic%2C%20high%20quality%20illustration&width=1800&height=900&seq=hero-galgame-2026&orientation=landscape"
              alt="galgame资源网站精选推荐 - 免费下载与汉化资源汇总"
              title="galgame资源网站精选推荐"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
              <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 max-w-3xl leading-tight">
                galgame资源网站精选推荐
              </h1>
              <p className="text-sm md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
                精心汇总主流galgame资源网站，涵盖免费下载、汉化补丁、攻略合集与最新资源更新，帮助玩家快速找到可靠的galgame资源网站，收藏即用，告别资源荒。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <Link
                  to="/category/download"
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  浏览资源网站
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-background-50/20 text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Grid */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                资源分类导航
              </h2>
              <p className="text-sm text-foreground-500 max-w-2xl mx-auto">
                按需查找，快速定位你需要的galgame资源网站类型
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${cat.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-base text-foreground-900 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                    {cat.description}
                  </p>
                  <span className="text-xs text-primary-600 font-medium">
                    {categorySiteCount[cat.slug] || 0} 个站点 &rarr;
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* Featured Sites */}
          <section className="bg-background-100 py-14 md:py-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                    精选推荐站点
                  </h2>
                  <p className="text-sm text-foreground-500">
                    经过严格筛选的优质galgame资源网站
                  </p>
                </div>
                <Link
                  to="/category/download"
                  className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
                >
                  查看全部 &rarr;
                </Link>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {featuredSites.map((site) => (
                  <div
                    key={site.id}
                    className="p-5 rounded-lg bg-background-50 border border-background-200/70 transition-all duration-300"
                  >
                    <div className="flex items-start gap-3 mb-3">
                      <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                        <img
                          src={site.logoUrl}
                          alt={site.name}
                          title={site.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-heading text-base text-foreground-900 mb-0.5">
                          {site.name}
                        </h3>
                        <div className="flex items-center gap-1 mb-1">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`text-xs ${
                                i < Math.floor(site.rating)
                                  ? 'ri-star-fill text-primary-500'
                                  : 'ri-star-line text-foreground-300'
                              }`}
                            ></i>
                          ))}
                          <span className="text-xs text-foreground-500 ml-1">{site.rating}</span>
                        </div>
                      </div>
                    </div>
                    <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                      {site.description}
                    </p>
                    <div className="flex items-center flex-wrap gap-1.5">
                      {site.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                  最新文章
                </h2>
                <p className="text-sm text-foreground-500">
                  galgame资源与攻略相关的精选文章
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.slice(0, 3).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={article.thumbnailUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                      <span>{article.date}</span>
                      <span>&middot;</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </section>

          {/* FAQ Section */}
          <section className="bg-background-100 py-14 md:py-20">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-12">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500">
                  关于galgame资源网站的常见疑问解答
                </p>
              </div>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <details
                    key={index}
                    className="group rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <h3 className="text-sm font-medium text-foreground-900 pr-4">
                        {faq.question}
                      </h3>
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}